module.exports = __webpack_public_path__ + "img/ihsane-foto-hoofd-klein.b5b50676.jpg";